import axios from 'axios'
const apiUrl = window.slbosUrl // || 'https://api.breezeline.com'
const prefix = `${apiUrl}/api/v1`
// To validate the request the API will
// ask for last name and account number
axios.defaults.timeout = 1000 * 10

export default {
    verifyCaptcha (payload) {
        return axios.post(`${prefix}/recaptcha/siteverify`, {
            response: payload.token
        })
    },
    auth (payload) {
        return axios.post(`${prefix}/slbos/auth`, {
            'last_name': payload.lastName,
            'account_id': payload.accountNumber
        })
    },
    create (payload) {
        return axios.post(`${prefix}/contec/orders/new`, {
            'last_name': payload.lastName,
            'account_id': payload.accountNumber,
            'customer': payload.customer,
            'orderItems': payload.orderItems
        })
    },
    retrieveOrders (payload) {
        return axios.post(`${prefix}/contec/orders`, {
            'last_name': payload.lastName,
            'account_id': payload.accountNumber
        })
    },
    delete (orderId, payload) {
        return axios.delete(`${prefix}/contec/orders/${orderId}`, {
            data: {
                'last_name': payload.lastName,
                'account_id': payload.accountNumber
            }
        })
    }
}
